import React from 'react';
import { KPIContent, KPIContentProps } from '../blocks/KPIContent';
import styles from './KPICard.module.scss';

export interface KPICardProps extends KPIContentProps {}

export const KPICard: React.FC<KPICardProps> = ({ kpiCaption, kpiMetric, kpiLabel, className }) => {
  return (
    <div className={styles.kpi_card_container}>
      <KPIContent
        kpiCaption={kpiCaption}
        kpiMetric={kpiMetric}
        kpiLabel={kpiLabel}
        className={className}
      />
    </div>
  );
};
export default KPICard;
